import React, { useState, useEffect } from "react";
import { Badge, Col, Row } from "react-bootstrap";

import ListPagination from "../../../Components/Pagination";
import { activityListPerPage } from "../../../Utilities/Helper";
import GroupListing from "../../../Components/GroupListing";
import { getGroupsWithSTMCount } from "../../../Services/AdminManageUsersServices";

export default function GroupListingForSTM() {
  const [users, setUsers] = useState([]);
  const [totalUser, setTotalUser] = useState();
  const [totalSTMCount, setTotalSTMCount] = useState();
  const [currentPage, setCurrentPage] = useState("");
  const [showSpinnerForActivities, setShowSpineerForActivities] =
    useState(true);

  useEffect(() => {
    async function allUsers() {
      const filter = "recordperpage=" + activityListPerPage + currentPage;
      await getGroupsWithSTMCount(filter)
        .then((res) => {
          const result = res;
          setUsers(result.groupModels);
          setTotalUser(result.totalGroupCount);
          setTotalSTMCount(result.totalSTMCount);
          setShowSpineerForActivities(false);
        })
        .catch((err) => {
          console.log("Support: ", err);
          setShowSpineerForActivities(false);
        });
    }
    allUsers();
  }, [currentPage]);

  const pageChangeHandler = (page) => {
    setCurrentPage(`&page=${page}`);
    setShowSpineerForActivities(true);
  };

  return (
    <div className="container p-0">
      <h1 className="page-title">
        Support Team Members{" "}
        <Badge
          pill
          bg="danger"
          className="bg-warning text-white px-3 ml-3 font-weight-normal"
        >
          {totalSTMCount}
        </Badge>
      </h1>
      <div className="dashboard-wrapper resumes-page admin-members"> 
        <Row>
          <Col md={12}>
            <div className="dashboard-box activities dashboard-col-bg mb-4">
              <GroupListing
                groups={users}
                showSpinner={showSpinnerForActivities}
              />
              {users.length !== 0 && (
                <ListPagination
                  recordPerPage={activityListPerPage}
                  TotalRecord={totalUser}
                  className="mt-3"
                  onPageChange={pageChangeHandler}
                />
              )}
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}
// export default ActivitiesList;
